<template>
  <Understanding/>
</template>

<script>
import Understanding from '../../components/Understanding'

export default {
  components: {
    Understanding
  },
  name: 'Treatment',
  mounted() {
    let section = this.$el.querySelector("#" + this.$route.name);
    if (section) {
      section.scrollIntoView(true);
      window.scrollBy(0, -64);
    }
  }
}
</script>